/* eslint-disable prettier/prettier */
import { parseInvestment } from './investment';
import { parseImpact } from './impact';
import { parseOverview } from './overview';
import { parseIntervention } from './intervention';
import { parseNarrative } from './narrative';
import { parseBudget } from './budget';
import { parseBeneficiaries } from './beneficiaries';

export const mixedQuery = () => {
  let query =       '{'
  query +=            `allPortfolios { `
  query +=                'edges { '
  query +=                  'node { '
  query +=                      'id '
  query +=                      'name '
  query +=                      'year '
  query +=                      'relationshipManagerId '
  query +=                      'reviewLevel '
  query +=                      'funder { '
  query +=                       'name '
  query +=                     '} '
  query +=                    'investments { '
  query +=                      'edges { '
  query +=                        'node { '
  query +=                          'externalId '
  query +=                          'recipient '
  query +=                          'cashAmount '
  query +=                          'cashDescription '
  query +=                          'goodsAmount '
  query +=                          'goodsDescription '
  query +=                          'volunteerismAmount '
  query +=                          'volunteerismDescription '
  query +=                          'servicesAmount '
  query +=                          'servicesDescription '
  query +=                          'programNameByDonor '
  query +=                          'grantee { '
  query +=                            'name '
  query +=                          '} '
  query +=                          'invitation { '
  query +=                            'edges { '
  query +=                              'node { '
  query +=                                'firstName '
  query +=                                'lastName '
  query +=                                'email '
  query +=                              '} '
  query +=                            '} '
  query +=                          '} '
  query +=                          'allocations { '
  query +=                            'edges { '
  query +=                              'node { '
  query +=                                'claim '
  query +=                                'amount '
  query +=                                'tier '
  query +=                                'report { '
  query +=                                  'id '
  query +=                                  'dbId '
  query +=                                  'name '
  query +=                                  'reportDescription '
  query +=                                  'totalCost '
  query +=                                  'totalBudgetInitial '
  query +=                                  'totalBudgetVariance '
  query +=                                  'costCurrentDirectCash '
  query +=                                  'costCurrentIndirectCash '
  query +=                                  'costCurrentDirectInKind '
  query +=                                  'costCurrentIndirectInKind '
  query +=                                  'costInitialDirectCash '
  query +=                                  'costInitialIndirectCash '
  query +=                                  'costInitialDirectInKind '
  query +=                                  'costInitialIndirectInKind '
  query +=                                  'costCommentDirectCash '
  query +=                                  'costCommentIndirectCash '
  query +=                                  'costCommentDirectInKind '
  query +=                                  'costCommentIndirectInKind '
  query +=                                  'budgetNote1 '
  query +=                                  'budgetNote1Date '
  query +=                                  'budgetNote2 '
  query +=                                  'budgetNote2Date '
  query +=                                  'aditionalBudgetNotes '
  query +=                                  'directCashVariance '
  query +=                                  'indirectCashVariance '
  query +=                                  'directInkindVariance '
  query +=                                  'indirectInkindVariance '
  query +=                                  'startDate '
  query +=                                  'endDate '
  query +=                                  'serviceName '
  query +=                                  'stage '
  query +=                                  'stageStatus '
  query +=                                  'updatedAt '
  query +=                                  'taxonomySubjectId '
  query +=                                  'primaryInterventionType '
  query +=                                  'primaryInterventionSubtypes '
  query +=                                  'interventionDosageLevel '
  query +=                                  'interventionDosageNumber '
  query +=                                  'taxonomySubjectLevel '
  query +=                                  'primaryInterventionDescription '
  query +=                                  'beneficiaryDescription '
  query +=                                  'successStory '
  query +=                                  'lessonLearned '
  query +=                                  'beneficiaryLocations { '
  query +=                                    'edges { '
  query +=                                      'node { '
  query +=                                        'location '
  query +=                                      '} '
  query +=                                    '} '
  query +=                                  '} '
  query +=                                  'beneficiaryDemographics { '
  query +=                                    'edges { '
  query +=                                      'node { '
  query +=                                        'percentage '
  query +=                                        'bdtName'
  query +=                                      '} '
  query +=                                    '} '
  query +=                                  '} '
  query +=                                  'feedbacks { '
  query +=                                    'edges { '
  query +=                                      'node { '
  query +=                                        'id '
  query +=                                        'funderText '
  query +=                                        'adminText '
  query +=                                        'granteeText '
  query +=                                      '} '
  query +=                                    '} '
  query +=                                  '} '
  query +=                                  'results { '
  query +=                                    'edges { '
  query +=                                      'node { '
  query +=                                        'successCriteria '
  query +=                                        'forecastInitial '
  query +=                                        'forecastCurrent '
  query +=                                        'forecastVariance '
  query +=                                        'currentForecastFundedClaim '
  query +=                                        'currentForecastFullClaim '
  query +=                                        'currentForecastCatalyzed '
  query +=                                        'leverage '
  query +=                                        'sroiPer10kFundedClaim '
  query +=                                        'sroiPer10kFullClaim '
  query +=                                        'classification '
  query +=                                        'indicator { '
  query +=                                          'dbId '
  query +=                                          'name '
  query +=                                          'definition '
  query +=                                        '} '
  query +=                                      '} '
  query +=                                    '} '
  query +=                                  '} '
  query +=                                '} '
  query +=                              '} '
  query +=                            '} '
  query +=                          '} '
  query +=                        '} '
  query +=                      '} '
  query +=                    '} '
  query +=                  '} '
  query +=                '} '
  query +=              '} '
  query +=            '} '

  return query;
};

const mergeByKey = (data, key) => {
  return data.reduce((result, row) => {
    const idx = result.findIndex(p => p[key] === row[key]);
    if (idx > -1) {
      // eslint-disable-next-line no-param-reassign
      result[idx] = { ...result[idx], ...row };
    } else {
      result.push(row);
    }
    return result;
  }, []);
};

export const parseQuery = (query, tabs) => {
  const investment = parseInvestment(query);
  const overview = parseOverview(query);
  const intervention = parseIntervention(query);
  const beneficiaries = parseBeneficiaries(query, tabs[3].sections);
  const impact = parseImpact(query, tabs[4].sections);
  const narrative = parseNarrative(query);
  const budget = parseBudget(query);
  const report = mergeByKey(
    [
      ...investment,
      ...overview,
      ...intervention,
      ...beneficiaries,
      ...impact,
      ...narrative,
      ...budget
    ],
    'ID'
  );
  return report;
};
